import { axiosInstance } from "./";

// Get Roles with status enabled
const getRoles = async () =>
  await axiosInstance.get("roles", { params: { status: "enabled" } });

export { getRoles };
